import { render } from "./EditClass.vue?vue&type=template&id=4b32b70c&scoped=true"
import script from "./EditClass.vue?vue&type=script&lang=js"
export * from "./EditClass.vue?vue&type=script&lang=js"

import "./EditClass.vue?vue&type=style&index=0&id=4b32b70c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b32b70c"]])

export default __exports__